import { Fragment } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Alerts, P } from "../../../AbstractElements";
import { Href } from "../../../Constants/Constants";
import { LinkLightSubTitle } from "../../../Data/UiKits/Alert";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { CommonLinkColorType } from "../../../Types/UiKitsType";

const CommonLinkColor: React.FC<CommonLinkColorType> = ({ title, data }) => {
  return (
    <Col xl="12">
      <Card>
        <CommonCardHeader title={title} span={LinkLightSubTitle} />
        <CardBody>
          <Row>
            {data &&
              data.map((item, index) => (
                <Col xl="6" key={index}>
                  {item.data &&
                    item.data.map((item, index) => (
                      <Fragment key={index}>
                        <P className="mb-1">{item.text}</P>
                        <Alerts color={item.class}>
                          <P className={`txt-${item.textClass}`}>
                            {"This is a "}
                            <a className={`alert-link txt-${item.textClass}`} href={Href}>
                              {item.alertText}
                            </a>
                            {" with an example link. Check it out."}
                          </P>
                        </Alerts>
                      </Fragment>
                    ))}
                </Col>
              ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default CommonLinkColor;
